import { render, staticRenderFns } from "./MBTIHome.vue?vue&type=template&id=0f7b9ab5&scoped=true"
import script from "./MBTIHome.vue?vue&type=script&lang=js"
export * from "./MBTIHome.vue?vue&type=script&lang=js"
import style0 from "./MBTIHome.vue?vue&type=style&index=0&id=0f7b9ab5&prod&scoped=true&lang=scss"
import style1 from "./MBTIHome.vue?vue&type=style&index=1&id=0f7b9ab5&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7b9ab5",
  null
  
)

export default component.exports